import React, { useState, useEffect } from 'react'
import { formatDate, capitalize } from '@helpers';
import PropTypes from 'prop-types';
import './leiterperson-zuweisung.scss';
import { useDirectus } from 'react-directus';
import { useTranslation } from 'react-i18next';

export default function SlotItem(props) {
    const { slot, leiterpersonen } = props;
    const { directus } = useDirectus();
    const { t } = useTranslation('anmeldung');

    const [checked, setChecked] = useState([]);

    const handleOnChange = (e, leiterpersonId) => {
        if (e.target.checked) {
            setChecked([...checked, leiterpersonId]);
        } else {
            setChecked(checked.filter((id) => id !== leiterpersonId));
        }

    }

    const updateLeierpersonen = async () => {

        const response = await directus.items('slots').updateOne(slot.id, {
            leiterpersonen: JSON.stringify(checked)
        });

        console.log(response)
    }

    useEffect(() => {
        if (slot.leiterpersonen) {
            setChecked(JSON.parse(slot.leiterpersonen));
        }
    }, []);

    useEffect(() => {
        updateLeierpersonen();
    }, [checked]);


    return (
        <div className="kalender__workshop-item">
            <div>
                <div className="date">{`${formatDate(slot.date)}, ${slot.kontingent} Workshops`}</div>
                <div className="zeit">{capitalize(slot.zeit)}</div>
            </div>
            <div className="leiterpersonen-wrapper">
                {leiterpersonen.map((leiterperson) => {
                    const isAvailable = JSON.parse(slot.availability) && JSON.parse(slot.availability).available.includes(leiterperson.id);
                    const isChecked = checked.includes(leiterperson.id);
                    return (
                        <div className={`leiterperson ${isAvailable ? 'available' : null}`} key={leiterperson.id}>
                            <input
                                type="checkbox"
                                id={`checkbox-${slot.id}-${leiterperson.id}`}
                                name={leiterperson.vorname}
                                checked={isChecked}
                                // Add an onChange handler if you need to handle changes
                                onChange={(e) => handleOnChange(e, leiterperson.id)}
                            />
                            <label htmlFor={`checkbox-${slot.id}-${leiterperson.id}`}>
                                {leiterperson.vorname} {leiterperson.nachname}
                            </label>
                        </div>
                    );
                })}
            </div>


            <div>
                <div className="button">
                    {JSON.parse(slot.availability) && JSON.parse(slot.availability).available
                        ? JSON.parse(slot.availability).available.length !== 1
                            ? JSON.parse(slot.availability).available.length + t(' Leiterpersonen verfügbar')
                            : JSON.parse(slot.availability).available.length + t(' Leiterperson verfügbar')
                        : 0 + ' ' + t('Leiterpersonen verfügbar')
                    }
                </div>
                <div className="button not">
                    {JSON.parse(slot.availability) && JSON.parse(slot.availability).unavailable + t(' Absagen')
                        ? JSON.parse(slot.availability).unavailable.length + t(' Absagen')
                        : 0 + t(' Absagen')
                    }

                </div>
            </div>
        </div>
    )

}

SlotItem.propTypes = {
    slot: PropTypes.object.isRequired,
}